import * as React from "react";
import { ModuleScreen } from "../../common/ModuleScreen";
import { IntegrationSelectionScreen } from "./IntegrationSelectionScreen";
import ErrorBoundary from "../../../ErrorBoundary";
import { useAddSiteOnboardingStore } from "./addSiteOnboardingStore";

export const AddSite = () => {
  const [visibleScreen, setVisibleScreen] = React.useState(<></>);

  const resetOnboarding = useAddSiteOnboardingStore(
    (state) => state.resetOnboarding
  );

  React.useEffect(() => {
    resetOnboarding();
    localStorage.setItem("healthMonitoringOnly", "false");
    setVisibleScreen(
      // <AddWebhookScreen />
      <IntegrationSelectionScreen setVisibleScreen={setVisibleScreen} />
    );
    localStorage.removeItem("siteJustDeleted");
    localStorage.removeItem("selectedIntegrationName");
    localStorage.setItem("immixAlertsSite", "false");
    localStorage.setItem("diceAlertsSite", "false");
    localStorage.setItem("sentinelAlertsSite", "false");
    localStorage.setItem("sureviewAlertsSite", "false");
    localStorage.setItem(
      "immixAlertPostObject",
      JSON.stringify({
        id: -1,
        immix_server: "",
        immix_port: "",
      })
    );
    localStorage.setItem(
      "diceAlertPostObject",
      JSON.stringify({
        id: -1,
        dice_server: "",
        dice_port: "",
      })
    );
    // Reset so a previous site's Evalink credentials never leak into a new
    // onboarding (the auto-add screen seeds its fields from this object).
    localStorage.setItem("evalinkAlertPostObject", JSON.stringify({}));
  }, [resetOnboarding]);

  return (
    <ErrorBoundary>
      <ModuleScreen
        text="Add Site"
        visibleScreen={visibleScreen}
        styling={
          "text-white absolute top-[1px] right-[485px] font-mulish text-[18px] p-3"
        }
      />
    </ErrorBoundary>
  );
};
